import { RegisterState } from '../../helpers/types/redux/state/register.types'

export const registerInitialState: RegisterState = {
  customer: {
    email: '',
    password: '',
    business_license: '',
  },
  business: {
    name: '',
    cnpj: '',
    phone: '',
    legal_representative: '',
    zipcode: '',
    city: '',
    state: '',
    street: '',
    neighborhood: '',
    number: '',
    country: '',
    complement: '',
    full_address: '',
    longitude: 0,
    latitude: 0,
  },
  configuration: {
    parking_space: 0,
    daily_price: '',
    hour_price: '',
    price_thirty_min: '',
    discount_first_hour: null,
    monthly: null,
    allow_scheduling: false,
    premium: false,
    business_hours: [],
    payment_methods: [],
  },
  characteristics: {
    characteristics: [],
    services: [],
  },
}
